import React, { useContext } from 'react';
import { Context } from '../Ticket';
import LogoKeno from '../../../../assets/img/logo-keno.png';
import LogoMega from '../../../../assets/img/logo-mega.png';
import LogoPower from '../../../../assets/img/logo-power.png';
import LogoMax3d from '../../../../assets/img/logo-max3d.png';
import LogoMax3dPro from '../../../../assets/img/logo-max3dpro.png';
import LogoLotto535 from '../../../../assets/img/logo-lotto535.png';

const logos = { keno: LogoKeno, mega: LogoMega, power: LogoPower, max3d: LogoMax3d, max3dpro: LogoMax3dPro, lotto535: LogoLotto535 };
const countLabel = count => `${Number(count || 0).toLocaleString('vi-VN')} vé`;

export default function GameQuickFilter({ counts = {}, loading }) {
  const { state, dispatch } = useContext(Context);
  const total = Object.values(counts).reduce((sum, count) => sum + Number(count || 0), 0);
  const games = [...(state.games || [])];
  Object.keys(counts).forEach(id => {
    if (!games.some(game => game.id === id)) games.push({ id, name: id });
  });
  const otherGames = games.filter(game => game.id !== 'keno');
  return <div className="ticket-game-counts" role="group" aria-label="Lọc nhanh theo trò chơi" aria-busy={loading}>
    {state.gameScope === 'keno'
      ? <div className="ticket-game-count active"><img src={LogoKeno} alt="Keno" /><strong>{loading ? '…' : countLabel(total)}</strong></div>
      : <>
        {[{ id: '', name: 'Tất cả' }, ...otherGames].map(game => <button type="button" key={game.id}
          className={`ticket-game-count${state.gameId === game.id ? ' active' : ''}`}
          aria-label={`Lọc ${game.name}`} aria-pressed={state.gameId === game.id}
          disabled={loading || !state.gameScope}
          onClick={() => { if (state.gameId !== game.id) dispatch({ type: 'SUBMIT_FILTER', payload: { gameId: game.id } }); }}>
          {logos[game.id] ? <img src={logos[game.id]} alt={game.name} title={game.name} /> : <span>{game.name}</span>}
          <strong>{loading ? '…' : countLabel(game.id ? counts[game.id] : total)}</strong>
        </button>)}
      </>}
  </div>;
}
